import { render } from "./index.vue?vue&type=template&id=3f20cfca&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=3f20cfca&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f20cfca"],['__file',"src/componentBase/BaseCode/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3f20cfca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3f20cfca', __exports__)) {
    api.reload('3f20cfca', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=3f20cfca&scoped=true", () => {
    api.rerender('3f20cfca', render)
  })

}


export default __exports__